/*
 * @Author: zl
 * @Date: 2022-03-08 13:50:03
 * @LastEditTime: 2022-09-06 17:50:01
 * @LastEditors: zl
 * @Description: 
 */
import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import { Loading, Message } from 'element-ui'

let origin = window.origin
// create an axios instance
const service = axios.create({
    baseURL: origin + '/analysis', // api 的 base_url
    timeout: 600000 // request timeout
})

let loadingInstance = null

// 请求拦截器
service.interceptors.request.use(
    config => {
        // loadingInstance = Loading.service({
        //     lock: true,
        //     text: '数据加载中，请稍后...',
        //     spinner: 'el-icon-loading',
        //     background: 'rgba(0, 0, 0, 0.4)'
        // })

        // 序列化 使数据变为url 的形式并用 & 拼接
        // if (config.method === 'post') {
        //     config.data = qs.stringify(config.data)
        // }

        // Do something before request is sent
        if (sessionStorage.getItem('token')) {
            // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
            config.headers['token'] = sessionStorage.getItem('token')
        }
        return config
    },
    err => {
        // loadingInstance.close()
        Message.error('请求错误')
        return Promise.reject(err)
    }
)

// 返回状态判断(添加响应拦截器)
service.interceptors.response.use(
    res => {
        // console.log(res)
        if (res.config.responseType === 'blob') {
            // console.log(res)
            return Promise.resolve(res)
        }

        // 如果返回code = 0， 为正确 retCode(文件服务器)
        if (res.data.code === 0 || res.data.retcode === 0) {
            // loadingInstance.close()
            // Message.success(res.data.msg)
            return res.data
        } else {
            // loadingInstance.close()
            Message.error(res.data.msg)
        }
    },
    err => {
        console.log(err)
        // loadingInstance.close()
        Message.error('请求失败，请稍后再试')
        return Promise.reject(err)
    }
)

export default service